export default "__VITE_ASSET__ez317ca8__"